import { queryOptions } from '@tanstack/react-query';

import type { Schema } from '@/shared/api/generated';

import { aggregateIssues } from './aggregate-issues';
import { getIssueList } from './get-issue-list';

export const issueQueryKeys = {
  all: ['issue'] as const,
  lists: () => [...issueQueryKeys.all, 'list'] as const,
  list: (workspaceId: string) =>
    [...issueQueryKeys.lists(), workspaceId] as const,
  aggregates: () => [...issueQueryKeys.all, 'aggregate'] as const,
  aggregate: (params: {
    filter: StructuredFilter;
    period: string;
    workspaceId: string;
    issue?: string;
  }) => [...issueQueryKeys.aggregates(), params] as const,
  summaries: () => [...issueQueryKeys.all, 'summary'] as const,
  summary: (name: string, filter: StructuredFilter) =>
    [...issueQueryKeys.summaries(), { name, filter }] as const,
};

/**
 * 이슈 목록 조회 queryOptions
 */
export function issueListQueryOptions({
  workspaceId,
}: {
  workspaceId: string;
}) {
  return queryOptions({
    queryKey: issueQueryKeys.list(workspaceId),
    queryFn: () => getIssueList({ workspace_id: workspaceId }),
  });
}

/**
 * 이슈 집계 queryOptions
 */
export function aggregateIssuesQueryOptions(
  params: {
    filter: StructuredFilter;
    period: string;
    workspaceId: string;
    issue?: string;
  },
  options?: { enabled?: boolean; staleTime?: number },
) {
  const { filter, period, issue, workspaceId } = params;

  return queryOptions({
    queryKey: issueQueryKeys.aggregate({ filter, period, issue, workspaceId }),
    queryFn: () =>
      aggregateIssues({
        workspace_id: workspaceId,
        filter_set: filter,
        period: period as Schema<'DatePeriod'>,
        issue,
      }),
    ...options,
  });
}
